import bannerThrive from "@assets/thrive_images/banner-thrive.png";
import bannerThriveLg from "@assets/thrive_images/banner-thrive-lg.png";
import { useWindowSize } from "@hooks/useWindowSize";

/**
 * Component to render thrive banner on top of thrive page
 * https://www.figma.com/design/UWKZEzXYf0Gf5e6sfqsKVC/THRIVE-WORKING-FILE?node-id=8869-84185&m=dev
 */
const ThriveTopBanner = (): React.ReactElement => {
  const { isScreenMD } = useWindowSize();

  return (
    <div data-testid="thrive-top-banner" className="-mx-4 md:-mx-9">
      <img
        alt="thrive-top-banner"
        width={1174}
        height={230}
        className="w-full py-2 lg:py-6"
        src={isScreenMD ? bannerThriveLg : bannerThrive}
      />
    </div>
  );
};

export default ThriveTopBanner;
